import {
  created_by,
  otherAPIHeaders,
  uploadAPIHeaders,
} from "../shared-resources/dumpData";

export function createProjectAPI(body) {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/project/createProject`, {
    method: "POST",
    headers: otherAPIHeaders,
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectAnalyticsAPI(body, myView, showInactiveProjects) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getProjAnalyticsData?dropdown=${myView}&isShowInactive=${showInactiveProjects}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getNoOfProjectsByTypeAPI(body, myView, showInactiveProjects) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getNoOfProjectsByType?dropdown=${myView}&isShowInactive=${showInactiveProjects}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getOverAllProgressAPI(body, myView, showInactiveProjects) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getOverAllProgress?dropdown=${myView}&isShowInactive=${showInactiveProjects}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectDetailsByIdAPI(id) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getProjectDetailsById?projectId=${id}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateProjectDetailsByIdAPI(
  body,
  id,
  forceDeallocateResources
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/updateProjectDetailsById?projectId=${id}&forceDeallocateResources=${forceDeallocateResources}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getKanbanDataAPI(id) {
  return fetch(
    // `${process.env.KIRKLAND_APP_API_URL}/project/getKanbanData/${id}`,
    `${process.env.KIRKLAND_APP_API_URL}/project/getKanbanData?projectId=${id}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getKanbanResourceDataAPI(id) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getResourceBy${id}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addResourceAPI(body) {
  // return fetch(`${process.env.KIRKLAND_APP_API_URL}/project/addResource`, {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateKanbanDataNew`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function addResourceRequestsAPI(body) {
  // return fetch(`${process.env.KIRKLAND_APP_API_URL}/project/addResource`, {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/saveResourceRequest`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function removeResourceAPI(mapId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/removeResource?mapId=${mapId}&modifiedBy=${created_by}`,
    {
      method: "DELETE",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAddResourceBySkillRoleIdAPI(roles, skills, getDateRange) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getAddResourceBySkillRoleId?roles=${roles}&skills=${skills}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(getDateRange),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getResourceByResourceIdAPI(resourceId, getDateRange, mapId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/resource/getMaxPossibleFteByResourceId?resourceId=${resourceId}&mapId=${mapId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(getDateRange),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getProjectListAPI(roles, skills) {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/project/getProjectList`, {
    method: "GET",
    headers: otherAPIHeaders,
  })
    .then((res) => res.json())
    .catch((err) => err);
}
export function getPLStatementBudgetAPI(year, projectId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getProjectFinanceBudgetSummary?financialYear=${year}&projectId=${projectId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getPLStatementForecastAPI(year, projectId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getProjectFinanceForecastSummary?financialYear=${year}&projectId=${projectId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getBudgetVsForecastAPI(year, projectId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getBudgetVsForecastChart?financialYear=${year}&projectId=${projectId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getBreakdownChartAPI(year, projectId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getBreakdownChart?financialYear=${year}&projectId=${projectId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getTotalCostAPI(body) {
  return fetch(`${process.env.KIRKLAND_APP_API_URL}/project/getTotalCostData`, {
    method: "POST",
    headers: otherAPIHeaders,
    body: JSON.stringify(body),
  })
    .then((res) => res.json())
    .catch((err) => err);
}
export function getTotalBudgetAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getTotalBudgetData`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadProjectAnalyticsAPI(
  body,
  myView,
  showInactiveProjects
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/downloadProjectAnalytics?dropdown=${myView}&isShowInactive=${showInactiveProjects}`,
    {
      method: "POST",
      headers: { ...uploadAPIHeaders, ["Content-Type"]: "application/json" },
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getNamedAllocatedResourceDetailsAPI(
  year,
  projectId,
  frequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getNamedAllocatedResourceDetails?financialYear=${year}&projectId=${projectId}&allocationFrequency=${frequency}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getNamedAllocatedResourceDetailsByMapIdAPI(
  year,
  projectId,
  frequency,
  mapId
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getNamedAllocatedResourceDetailsByMapId?financialYear=${year}&projectId=${projectId}&allocationFrequency=${frequency}&mapId=${mapId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function acceptCompleteResourceRequestAPI(mapId, body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/acceptCompleteResourceAllocation?mapId=${mapId}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getUnnamedAllocatedResourceDetailsAPI(
  year,
  projectId,
  frequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getUnnamedAllocatedResourceDetails?financialYear=${year}&projectId=${projectId}&allocationFrequency=${frequency}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateNamedAllocatedResourceDetailsAPI(
  body,
  year,
  frequency,
  projectId,
  goBeyondAvailableFteLimit
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateKanbanDataNew?financialYear=${year}&allocationFrequency=${frequency}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function updateUnnamedAllocatedResourceDetailsAPI(
  body,
  year,
  frequency,
  projectId,
  goBeyondAvailableFteLimit
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateKanbanDataNew?financialYear=${year}&allocationFrequency=${frequency}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addToProjectNamedAPI(
  body,
  year,
  frequency,
  projectId,
  goBeyondAvailableFteLimit = true
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateKanbanDataNew?financialYear=${year}&allocationFrequency=${frequency}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function addToProjectUnnamedAPI(
  body,
  year,
  frequency,
  projectId,
  goBeyondAvailableFteLimit = true
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateKanbanDataNew?financialYear=${year}&allocationFrequency=${frequency}&goBeyondAvailableFteLimit=${goBeyondAvailableFteLimit}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getRequestResourceByFiltersAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getRequestResourceByFilters`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getRequestResourceByFiltersByRMAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getRequestResourceByFiltersByRM`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}
export function getDownloadCreateProjectExcelFileAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/downloadCreateProjectExcelFile`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}
export function createProjectFromExcelAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createProjectFromExcel`,
    {
      method: "POST",
      headers: uploadAPIHeaders,
      body: body,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function updateProjectFavoritesStatusAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/updateProjectFavoritesStatus`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function showAddNamedUnnamedResourceButtonsAPI(projectId) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/showAddNamedUnnamedResourceButtons?projectId=${projectId}`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadResourceDelinquenciesReportAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/downloadResourceDelinquenciesReport`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function getResourceDelinquenciesReportAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getResourceDelinquenciesReport`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function getAdminSupportActivitiesTableAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/getAdminSupportActivitiesTable`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function createUpdateAdminSupportActivityAPI(body) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateAdminSupportActivity`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadAdminSupportActivityAPI() {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/downloadAdminSupportActivity`,
    {
      method: "GET",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function createUpdateResourceAdminSupportActivityAPI(
  body,
  forceDeallocateResources
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/createUpdateResourceAdminSupportActivity?forceDeallocateResources=${forceDeallocateResources}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.json())
    .catch((err) => err);
}

export function downloadFilteredProjectAnalyticsAPI(
  body,
  myView,
  showInactiveProjects
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/downloadFilteredProjectAnalytics?dropdown=${myView}&isShowInactive=${showInactiveProjects}`,
    {
      method: "POST",
      headers: { ...uploadAPIHeaders, ["Content-Type"]: "application/json" },
      body: JSON.stringify(body),
    }
  )
    .then((res) => res.blob())
    .catch((err) => err);
}

export function downloadProjectAllAllocationDataChartAPI(
  projectId,
  allocationFrequency
) {
  return fetch(
    `${process.env.KIRKLAND_APP_API_URL}/project/downloadProjectAllAllocationDataChart?projectId=${projectId}&allocationFrequency=${allocationFrequency}`,
    {
      method: "POST",
      headers: otherAPIHeaders,
    }
  )
    .then((res) => {
      if (res.status === 200) {
        let fileName = "";
        res.headers.forEach(function (val, key) {
          if (key === "content-disposition")
            fileName = val.split(";")[2].split('="')[1].split('.xlsx"')[0];
        });
        localStorage.setItem("downloadFileName", fileName);
        return res.blob();
      } else {
        return { status: 400 };
      }
    })
    .catch((err) => err);
}
